import { IgetBackofficeConfigurationResponse } from '../../../../../types/configuration.types';
import UserPermissionsForm from '../UserPermissionsForm/UserPermissionsForm';
import './UsersPermissionsGroupsSection.scss';

const UsersPermissionsGroupsSection = ({
  permissionsData,
  updateDataCallback
}: {
  permissionsData?: IgetBackofficeConfigurationResponse;
  updateDataCallback?: () => void;
}) => {
  const { usersPermissions, permissionGroups } = permissionsData || {};

  return (
    <div className="usersPermissionsGroupsSection">
      <div className="sectionTitle">Grupos de permisos por usuario</div>
      <div className="columnTitles">
        <div className="email">Correo</div>
        <div className="groups">Grupos a los que pertenece el usuario</div>
      </div>
      <div className="userPermissions">
        {usersPermissions &&
          !!usersPermissions.length &&
          usersPermissions?.map(user => {
            return (
              <UserPermissionsForm
                key={user.email}
                userData={user}
                permissionGroups={permissionGroups}
                updateDataCallback={updateDataCallback}
              />
            );
          })}
      </div>
    </div>
  );
};

export default UsersPermissionsGroupsSection;
